import React from "react"
import AppLaunchDashboard from "@views/features/app-launch-dashboard"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - App Launch Dashboard"
      keywords={[
        `engineid`,
        `security`,
        `app launch`,
        `consolidate apps`,
        `saml`,
        `openid`,
        `federated login`,
        `authentication`,
        `authorization`,
        `api`,
        `cloud`,
        `development`,
        `sdk`,
        `identity management`,
        `access management`,
      ]}
    />
    <AppLaunchDashboard />
  </div>
)

export default IndexPage
